import { ReactNode } from "react";
import Image from "next/image";
import { customEvent } from "goi_common";

import { ChevronRightIcon, MapPinIcon } from "@/components/DirectionsIcons";
import type {
  MubinsoFacilityLink,
  MubinsoNearbyParlor,
} from "@/utils/buildMubinsoPageProps";

interface MubinsoNearbyParlorsProps {
  parlors: MubinsoNearbyParlor[];
  companyName: string;
}

export const MubinsoNearbyParlors = ({
  parlors,
  companyName,
}: MubinsoNearbyParlorsProps) => {
  if (parlors.length === 0) return null;

  return (
    <section className="mb-nearby" aria-labelledby="mb-nearby-title">
      <h2 id="mb-nearby-title" className="mb-nearby__title">
        <MapPinIcon size={16} />
        {`${companyName} 주변 장례식장`}
      </h2>
      <ul className="mb-list">
        {parlors.map((parlor) => (
          <li key={parlor.id}>
            <a
              className="mb-list__row"
              href={`/place/${parlor.id}/mubinso/`}
              onClick={() =>
                customEvent({
                  newGtm: {
                    path: "prlr_mubinso",
                    trigger_and_target: "btn_nearby_parlor",
                  },
                })
              }
            >
              {parlor.imageUrl && (
                <Image
                  className="mb-list__thumb"
                  src={parlor.imageUrl}
                  alt=""
                  width={72}
                  height={72}
                  unoptimized
                />
              )}
              <span className="mb-list__body">
                <span className="mb-list__name">{parlor.name}</span>
                {parlor.distanceLabel && (
                  <span className="mb-list__meta">{parlor.distanceLabel}</span>
                )}
              </span>
              <ChevronRightIcon size={16} />
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};

interface MubinsoFacilityListProps {
  id: string;
  title: string;
  icon: ReactNode;
  facilities: MubinsoFacilityLink[];
  trigger: "btn_nearby_charnel" | "btn_nearby_cremat";
}

/** 인근 봉안당, 인근 화장장이 공유하는 목록 */
export const MubinsoFacilityList = ({
  id,
  title,
  icon,
  facilities,
  trigger,
}: MubinsoFacilityListProps) => {
  if (facilities.length === 0) return null;

  return (
    <section className="mb-facility" aria-labelledby={id}>
      <h2 id={id} className="mb-nearby__title">
        {icon}
        {title}
      </h2>
      <ul className="mb-list">
        {facilities.map((facility) => (
          <li key={facility.id}>
            <a
              className="mb-list__row"
              href={facility.href}
              onClick={() =>
                customEvent({
                  newGtm: {
                    path: "prlr_mubinso",
                    trigger_and_target: trigger,
                  },
                })
              }
            >
              <span className="mb-list__body">
                <span className="mb-list__name">{facility.name}</span>
                {facility.distanceLabel && (
                  <span className="mb-list__meta">
                    {facility.distanceLabel}
                  </span>
                )}
              </span>
              <ChevronRightIcon size={16} />
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};
